<template>
  <div>

    <div>
      <v-container fluid id="main" class="toHide">
        <v-row row wrap class="justify-center">
         <p class="display-1 ml-3">Professional Service Options</p>
       </v-row>

       <template>
        <v-card class="mx-auto my-1">
          <v-col>
           <v-row class="pl-2">
             <v-text-field text-capitalize label="Customer Name: " v-model="customerName" class="text-center" id="cName" type="text"></v-text-field>
             <v-text-field label="Invoice: " v-model="invoiceNum" class="text-center" type="number" id="invoice"></v-text-field>
           </v-row>
           <v-row class="pl-2">
             <v-text-field label="Technician Name: " v-model="techName" class="text-capitalize text-center" id="tName"></v-text-field>         
             <v-text-field label="Date: " class="text-center" v-bind:value="dateNow"></v-text-field>
           </v-row>
         </v-col>
       </v-card>
     </template>

     <v-row>

      <template>
        <v-col cols="12">
          <v-card max-width="" min-height="342" class="mx-auto">
            <v-card-title>
              <p title class="font-weight-regular font-italic title">Find Your Item By Group/Search</p>
            </v-card-title>
            <v-col cols="12">
              <v-text-field v-model="search" autocomplete="off" placeholder="Search" solo rounded outlined clearable ></v-text-field>
            </v-col>
            <v-card-text>
              <v-container fluid>
                <p class="title" v-if="groupSelected"><a href="" @click.prevent="items = [], groupSelected = null">All Groups</a> > {{groupSelected}}</p>
                <!-- display 1 -->
                <!-- level buttons -->
                <v-row v-if="items.length == 0">
                  <v-row class="lightbox white--text pa-2 fill-height mx-auto">
                    <template>
                      <v-img
                      class="ma-1 pa-2"
                      v-for="group in groups"
                      :key="group.id" 
                      @click="showGroupItems(group.name)"
                      :src="group.imageUrl"
                      gradient="to top, rgba(100,115,201,.03), rgba(25,32,72,.05), rgba(25,32,72,.07), rgba(25,32,72,.15), rgba(25,32,72,.7)"
                      width="250"
                      max-width="250"
                      height="150"
                      max-height="150"
                      contain
                      >
                      <div class="title pt-0 textShadow text-uppercase">{{ group.name }}</div>
                    </v-img>
                  </template>
                </v-row>
              </v-row>

              <!-- display 2 -->
              <!-- items Listing Display-->
              <v-row v-if="items.length != 0" class="lightbox white--text pa-2 fill-height mx-auto">
                <template>
                  <v-img
                  class="ma-1 pa-2 animated my-1 mx-1 clone grey lighten-5 black--text text--lighten-5"
                  :key="item.id" 
                  v-for="item in items" 
                  @click="selectedItems.push({...item, qty: 1}), add(item), anim($event)"
                  :src="item.imageUrl || 'https://placeimg.com/250/150/nature/sepia'"
                  gradient="to top, rgba(100,115,201,.03), rgba(25,32,72,.05), rgba(25,32,72,.07), rgba(25,32,72,.15), rgba(25,32,72,.7)"
                  width="250"
                  max-width="250"
                  height="150"
                  max-height="150"
                  contain
                  >
                  <div class="subtitle-1 pt-0 textShadow text-uppercase">{{ item.title }}</div>
                </v-img>
              </template>
            </v-row>

          </v-container>


        </v-card-text>
      </v-card>
    </v-col>
  </template>

</v-row>

<!-- SECOND STEP -->
<!-- chosen Items to work with Listing Display-->
<template v-if="selectedItems.length != 0">
  <v-card>
    <v-container>
      <v-row>
        <v-col cols="12"
        max-width="280"
        class="d-inline-flex row wrap justify-start mx-auto my-1">

        <!-- card for normal items -->
        <!-- v-if="!item.image" -->
        <v-card
        v-for="(item, x) in selectedItems"
        width="270"
        :key="item.id"
        color=""
        class="mx-1 mb-2 mx-xs-auto float-left"
        >
        <v-app-bar dark color="">

          <v-toolbar-title class="body-2">{{item.title | uppercase}}
            <br>{{item.price}}
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn icon
          @click="selectedItems.splice(x,1)">
          <v-icon light>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-img height="150" class="mt-1" :src="item.imageUrl" contain></v-img>
      <v-card-text>
        <v-list raised>
          <p class="text-right"><v-icon color="primary">add_photo_alternate</v-icon><br />Photo</p>
          <div v-for="num in 6" :key="`group-${num}`">
            <template>
              <v-list-item-group
              v-model="option[num].itemsList"
              :key="`group-${num}`"
              multiple
              >
              <v-row>
                <v-col cols="9" class="pa-0">
                  <v-list-item
                  pt-1 pb-1
                  :key="`item-${num}`"
                  :value="item"
                  active-class="blue--text text--accent-4"
                  @click="capAll()"
                  >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action class="mr-3">
                      <v-checkbox
                      :input-value="active"
                      :true-value="item"
                      color="deep-purple accent-4"
                      @click="toggle"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2 pb-0 text-left" v-text="`Option ${num}`"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-col>


              <v-col cols="3" class="ma-0 pa-0">
                <v-list-item-group
                v-model="option[num].image"
                :key="`group-${num}`"
                >
                <v-list-item
                pt-1 pb-1
                :key="`item-${num}`"
                :value="item"
                active-class="blue--text text--accent-4"
                >
                <template v-slot:default="{ active, toggle }">
                  <!-- <v-list-item-action> --><div class="pa-0 ma-0" style="height: 30px; bottom: 15px; position: relative;">
                    <v-switch
                    :input-value="active"
                    :true-value="item"
                    color="blue accent-4"
                    @click.native.stop="toggle"
                    ></v-switch>
                  <!-- </v-list-item-action> --></div>
                </template>
              </v-list-item>
            </v-list-item-group>


          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-list-item-group>
    </template>
  </div>

</v-list>
</v-card-text>
</v-card>

<!-- card for images -->
<!-- <v-card
v-for="(item, x) in selectedItems"
v-if="item.image"
width="270"
:key="item.id"
color=""
class="mx-1 mb-2 mx-xs-auto float-left"
>
<v-app-bar dark color="">

  <v-toolbar-title class="body-2">{{item.title | uppercase}}
  </v-toolbar-title>

  <v-spacer></v-spacer>
  <v-btn icon
  @click="selectedItems.splice(x,1)">
  <v-icon light>close</v-icon>
</v-btn>
</v-app-bar>
<v-img height="150" class="mt-1" :src="item.imageUrl" contain></v-img>
<v-card-text>
  <v-list raised>

    <div v-for="num in 6" :key="`group-${num}`">
      <template>
        <v-list-item-group
        v-model="option[num].image"
        :key="`group-${num}`"
        >
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list-item
            pt-1 pb-1
            :key="`item-${num}`"
            :value="item"
            active-class="blue--text text--accent-4"
            >
            <template v-slot:default="{ active, toggle }">
              <v-list-item-content>
                <v-list-item-title class="subtitle-2 pb-0 text-left" v-text="`Option ${num}`"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="mr-3">
                <v-checkbox
                :input-value="active"
                :true-value="item"
                color="deep-purple accent-4"
                @click="toggle"
                ></v-checkbox>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-col>
        
      </v-row>
      <v-divider></v-divider>
    </v-list-item-group>
  </template>
</div>

</v-list>
</v-card-text>
</v-card>
-->



</v-col>
</v-row>
</v-container>
</v-card>
</template>

<v-row class="toHide" v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0">
 <v-col> 
  <div class="mt-3 mb-3">
   <h2>Options Lists</h2>
 </div>
</v-col>
</v-row>

<!-- Options Lists -->

<v-row class="toHide" v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0">

 <v-expansion-panels>
  <v-expansion-panel v-for="(xx, ind) in Object.keys(option).length" :key="ind" class="shade" @click="expansionOpenToggle(xx)" >
   <v-expansion-panel-header class="py-0">
    <v-container fluid>
      <v-row>
        <!-- <v-toolbar-title class="subtitle-1 font-weight-bold d-flex"> -->
          <v-toolbar elevation="0" color="rgba(255, 255, 255, 0.0)" v-if="!expansionOpen[xx]">
            <v-toolbar-title class="d-flex"><span class="d-none d-sm-inline-block">Option</span> #{{xx}}
              <v-divider class="mx-2" inset vertical></v-divider>
              <div class="ml-2">
                <!-- <div class="subtitle-1 d-inline-flex font-weight-bold">Option #{{xx}}</div> -->
                <div class="pl-1 subtitle-1 d-inline-flex font-weight-bold">Total: {{ option[xx].total }} -</div>
                <div class="pl-1 subtitle-1 d-inline-flex font-weight-bold">Discount: {{ option[xx].discount }} -</div>
                <div class="pl-1 subtitle-1 d-inline-flex font-weight-bold">Investment: {{ option[xx].sum }}</div>
              </div>
              <div class="ml-12 subtitle-1 font-weight-medium">{{option[xx].warranty}}</div>

            </v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-divider class="pb-3" v-if="option[xx].itemsList.length >= 1 && !expansionOpen[xx]"></v-divider>
        <v-row v-if="!expansionOpen[xx]">
          <div>
            <ul class="ml-4">
              <li v-for="(item, i) in option[xx].itemsList" :key="i" class="text-capitalize p-2 my-1">{{ i+1 }}) {{ item.title}}</li>
            </ul>
          </div>

          <!-- <v-spacer></v-spacer> -->
        </v-row>
      </v-container>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <template>
        <div>
          <v-toolbar elevation="1" color="rgba(255, 255, 255, 0.0)" v-if="expansionOpen[xx]">
            <v-toolbar-title><span class="d-none d-sm-inline-block">Option</span> #{{xx}}
              <v-combobox
              class="ml-4 d-inline float-right mb-2"
              :items="warranties"
              v-model="option[xx].warranty"
              label="Warranty"
              placeholder="Warranty"
              ></v-combobox>
              <v-divider class="mx-2" inset vertical></v-divider>
              <div class="ma-3">
                <!-- <div class="subtitle-1 d-inline-flex font-weight-bold">Option #{{xx}}</div> -->
                <div class="pl-1 subtitle-1 d-inline-flex font-weight-bold">Total: {{ option[xx].total }} -</div>
                <div class="pl-1 subtitle-1 d-inline-flex font-weight-bold">Discount: {{ option[xx].discount }} -</div>
                <div class="pl-1 subtitle-1 d-inline-flex font-weight-bold">Investment: {{ option[xx].sum }}</div>
              </div>
            </v-toolbar-title>
          </v-toolbar>



          <v-data-table
          :headers="headers"
          :items="option[xx].itemsList"
          :items-per-page="itemsPerPage"
          hide-default-footer
          class="elevation-1"
          >

          <template v-slot:item.description="props">
            <v-edit-dialog
            :return-value.sync="props.item.description"
            large
            @save="save"
            @cancel="cancel"
            @open="open"
            @close="close"
            > {{ props.item.description }}
            <template v-slot:input>
              <v-textarea
              v-model="props.item.description"
              :rules="[max100chars]"
              label=""
              rows="3"
              counter
              solo
              autofocus
              maxlength="100"
              hint=""
              ></v-textarea>
            </template>
          </v-edit-dialog>
        </template>

        <template v-slot:item.price="props">
          <v-edit-dialog
          :return-value.sync="props.item.price"
          large
          @save="save"
          @cancel="cancel"
          @open="open"
          @close="close"
          > {{ props.item.price }}
          <template v-slot:input>
            <v-text-field
            type="number"
            v-model="props.item.price"
            :rules="[max25chars]"
            single-line
            counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.coupon="props">
        <v-edit-dialog
        :return-value.sync="props.item.coupon"
        large
        @save="save"
        @cancel="cancel"
        @open="open"
        @close="close"
        > {{ props.item.coupon }}
        <template v-slot:input>
          <v-text-field
          type="number"
          v-model="props.item.coupon"
          :rules="[max25chars]"
          label="Edit"
          single-line
          counter
          ></v-text-field>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.action="{ item }">
      <td class="justify-center layout px-0">
    <!-- <v-icon
    small
    class="mr-4"
    @click="editItem(item, xx)"
    >
    edit
  </v-icon> -->
  <v-icon
  color="#D32F2F"
  @click="removeItem(item, xx)"
  >
  delete
</v-icon>
</td>
</template>
<template v-slot:no-results>
  <div class="text-xs-center">
    Selected items will appear here
  </div>
</template>
</v-data-table>

<v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
  {{ snackText }}
  <v-btn text @click="snack = false">Close</v-btn>
</v-snackbar>
</div>
</template>

</v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>

</v-row>
<v-spacer></v-spacer>

<v-row class="mt-3 toHide">
 <v-col>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn 
        v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0"
        color="primary" 
        @click="reset" 
        class="mx-1 my-1 activated">Reset
      </v-btn>
      <v-btn 
      color="primary"
      v-on="on"
      class="mx-1 my-1 activated">Presets
    </v-btn>
    <v-btn 
    v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0"
    class="mrx1 amy-1 ctivated"
    color="primary"
    @click.stop="presetDialog = true">Save Preset
  </v-btn>
</template>
<v-list>
  <v-list-item
  v-for="(preset, index) in presets"
  :key="index"
  class="pl-3"
  >
  <v-icon
  medium
  color="#D32F2F"
  class="darken-4 d-inline mr-2"
  @click="deletePresetDialog = true, presetItem = preset"
  >
  delete
</v-icon>
<v-divider
class="mr-3"
inset
vertical
></v-divider>
<v-list-item-title style="cursor: pointer;" @click="loadPreset2(preset)">{{ preset.presetName | uppercase }}</v-list-item-title>

</v-list-item>
</v-list>
</v-menu>
</div>

</v-col>
</v-row>

<template v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0">
  <v-row justify-center>
    <v-dialog
    v-model="presetDialog"
    max-width="290"
    >
    <v-card>
      <v-card-title class="title">Give Your Preset A Name</v-card-title>
      <v-card-text>
        <v-row>
         <v-col cols="12">
          <v-text-field
          label="Preset Name"
          v-model="newPresetName"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
      color="primary darken-1"
      text
      @click="presetDialog = false"
      >
      Cancel
    </v-btn>

    <v-btn
    color="primary darken-1"
    text
    @click="presetDialog = false, saveNewPreset()"
    >
    Save
  </v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</v-row>
</template>


<template>
  <v-dialog
  v-model="deletePresetDialog"
  max-width="340"
  >

  <v-card>
    <v-card-title class="title">Delete Preset</v-card-title>
    <v-card-text>
      Delete Preset "{{presetItem.presetName}}"?
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
      color="primary darken-1"
      text
      @click="deletePresetDialog = false"
      >
      Cancel
    </v-btn>

    <v-btn
    color="primary darken-1"
    text
    @click="deletePreset()"
    >
    Delete
  </v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</template>


<hr class="hrs mt-4 mb-3">

<!-- Discount Options For Options Lists -->
<template class="mt-3 pt-3 mx-auto toHide" v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0">
  <v-card>
    <v-card-title primary-title class="mb-0 pb-0">
      Pricing Options
    </v-card-title>
    
    <v-row class="mt-3 pt-3 mx-auto toHide">

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title primary-title>
            Discounts
          </v-card-title>

          <v-radio-group d-flex class="px-3" v-model="selectedDiscount" @click="capAll()" >
            <v-radio v-for="(d, ind) in discounts" :value="d" :label="d.title" :key="ind"></v-radio>
          </v-radio-group>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title primary-title>
            Financing
          </v-card-title>
          <v-checkbox class="px-3 my-1 pt-0" label="Synchrony" v-model="financing" :value="financing"></v-checkbox>
          <v-checkbox class="px-3 pt-0 mt-0" label="Under 1k" v-model="financingUnder1k" :value="financingUnder1k"></v-checkbox>
          <v-radio-group d-flex class="px-3 pt-0"  v-model="financingSelected" @click="capAll()" >
            <v-radio label="Lowest Payment 5+ years // .0125" :value=".0125"></v-radio>
            <v-radio label="Deferred Interest 24 months // .04" :value=".04">
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title primary-title>
            Page Layout
          </v-card-title>
          <v-checkbox class="px-3 my-1 pt-0" label="Summary Section" v-model="summarySection" click="summarySection = !summarySection"></v-checkbox>
          <v-checkbox class="px-3 my-1 pt-0" label="Display Warranty" v-model="warranty" click="warranty = !warranty"></v-checkbox>
          <v-checkbox class="px-3 my-1 pt-0 d-flex" label="Alternative Good/Better/Best" v-model="alternative" click="alternative = !alternative"></v-checkbox>
        </v-card>
      </v-col>

    </v-row>
  </v-card>
</template>

<!-- display settings for print -->
<v-row class="toHide" v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0">
 <v-col>
  <div class="mt-xs-4">
   <h2 class="mb-3">Preview Section</h2>
   <!-- <v-btn color="primary" @click="" class="mr-1 m-3 activated">Email</v-btn> -->
   <!-- <v-btn color="primary" @click="createPdf()" class="mr-1 m-xs-3 activated">Save PDF</v-btn> -->
   <v-btn color="primary" @click="print" class="mr-1 m-xs-3 activated">Print</v-btn>
   <v-btn color="primary" @click="preview" class="mr-1 m-xs-3 activated">Preview</v-btn>

 </div>
</v-col>
</v-row>
</v-container>
<!-- container end -->

<!-- Final view for print -->

<template v-if="option[1].itemsList.length != 0 || option[2].itemsList.length != 0 || option[3].itemsList.length != 0" >
  <v-container class="mt-0 py-0 elevation-12" id="print">
    <v-row>
      <v-col class="py-0">
        <header id="header">
          <img class="invoiceNames" src="../assets/namesInvoice.png" alt="">
          <img height="140" class="logo d-none d-sm-inline-block" id="logo" :src="$store.state.company.imageUrl" alt="">
          <p class="cname text-capitalize">{{ customerName }} </p>
          <p class="tname text-capitalize">{{ techName }} </p> 
          <p class="invoice text-capitalize">{{ invoiceNum }} </p>
          <p class="date text-capitalize">{{ dateNow }} </p>
        </header>
      </v-col>
    </v-row>

    <!-- Summary Section -->
    <v-row light v-if="summarySection">
      <v-col class="py-0">
       <h4 class="text-left mb-3 mt-1 recommendations"><u>Recommendations/Diagnostics/Summary</u></h4>
       <!-- dividers here -->
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
       <p class="underline"></p>
     </v-col>
   </v-row>

   <v-row>
    <v-col class="py-0">
     <h5 class="mt-0 mb-3" id="solutions"><u>Solutions:</u>
      <!-- <h6 v-if="option[1].isCap || option[2].isCap || option[3].isCap || option[4].isCap || option[5].isCap || option[6].isCap" class="caption text-right pr-4">** Includes Comfort Assurance Plan Membership Discount</h6> -->
      <h6 v-if="selectedDiscount" class="caption text-right pr-4">{{ selectedDiscount.description }}</h6>
      <h6 class="caption text-right pr-4">{{ $store.state.company.priceDisclosure }}</h6>
      <h6 v-show="selectedDiscount.amount == 0" v-if="option[1].discount > 0 || option[2].discount > 0 || option[3].discount > 0 || option[4].discount > 0 || option[5].discount > 0 || option[6].discount > 0" class="caption text-right pr-4">** Discounts Applied</h6>
    </h5>
  </v-col>
</v-row>

<!-- options -->
<table class="tableOptions">
    <!-- <thead><tr><td>
      <div class="header-space">&nbsp;</div>
    </td></tr></thead> -->
    <tbody>
      <!-- <tr><td> -->

        <tr class="list-group shade" v-for="(s, i) in Object.keys(option).length" :key="i" v-if="option[s].itemsList.length != 0">
          <td class="list-group-item w-100 mx-0 shade py-1">

            <v-row>
              <v-col cols="10" class="py-1">
                <h6 class="ml-1 mt-0 options pb-1" :class="{ alternative: alternative }">{{!alternative ? "Option #" + s + ")" : `- ${alternatives[i]} -`}} <span v-if="option[s].sum > 0 && warranty" class="d-none d-sm-inline-block d-print-inline-block warranty">{{option[s].warranty}}</span></h6>
                <ul class="descriptionList">
                  <li class="myfont" v-for="(i, ind) in option[s].itemsList" :key="ind">
                    <span class="text-capitalize description">+ {{i.description}}</span>
                  </li>
                </ul>
              </v-col>

              <!-- Financing -->
              <v-col cols="2" 
              v-if="(option[s].sum >= 1000 || financingUnder1k) && financing"
              class="text-right mt-1 mb-0 pl-0 py-0">

              <v-img max-width="200" max-height="135" v-if="option[s].image != undefined " class="p-0 m-0 mb-2" :src="option[s].image.imageUrl" contain></v-img>

              <p class="pricing mb-0">Investment </p>
              <p class="pricing">{{ option[s].financeMonthlyPayment }} /  Month - {{option[s].financeAmount}}</p>
            </v-col>


            <!-- v-if="option[s].sum <= 1000 || !financing" -->
            <v-col cols="2"
            v-else 
            class="text-right mt-1 mb-0 pl-0 py-0">

            <v-img max-width="200" max-height="135" v-if="option[s].image != undefined " class="p-0 m-0 mb-2" :src="option[s].image.imageUrl" contain></v-img>

            <p v-if="option[s].discount > 0" class="mbNone pricing"> {{ option[s].total }} </p>
            <p v-if="option[s].discount > 0" class="mbNone pricing">** <u> - {{ option[s].discount }} </u></p>
            <p class="pricing mbNone">Investment ( {{ option[s].sum }} )</p>
          </v-col>

          <v-row>
          </v-row>
        </v-row>
<!--   </td>
</tr>
-->
</td></tr></tbody>
<tfoot><tr><td>
  <div class="footer-space">&nbsp;</div>
</td></tr></tfoot>
</table>

<footer id="footer" class="footer">
 <h2 class="headline font-weight-light font-italic text-xs-center"><i>{{company.footer | capitalize }}</i></h2>
 <h5 class="subtitle-1 font-weight-light font-italic text-xs-center" >{{company.companyPhone}} / {{company.companyWebsite}}</h5>
</footer>
<!-- </v-footer> -->

</v-container>
<!-- container-fluid end print section-->
</template>




<!-- end of print section -->

<!-- <div class="bottomContent"></div> -->
</div>
</div>
</template>
<script>

  import { bus } from '../main'
  import * as jsPDF from 'jspdf'
  import html2canvas from 'html2canvas'
  import firebase from '@/helpers/firebaseConfig'

  import Print from '../components/Print'
  import router from '../router'

  const db = firebase.firestore()
  export default {
   name: 'AnyHourOptions',
   components: {Print},
   data() {
    return {
      warranty: true,
      summarySection: true,
      alternative: false,
      alternatives: ['BEST', 'BETTER', 'GOOD', 'BASIC', 'Option 5', 'Option 6'],
      presetItem: {},
      deletePresetDialog: false,
      expansionOpen: {
        1:false,
        2:false,
        3:false,
        4:false,
        5:false,
        6:false
      },
      output: null,
      model: [],
      selectedItemsOptions: [],
      msg: '',
      selectedDiscount: {"amount":"0","name":"None","description":""},
      financing: true,
      financingUnder1k: false,
      financingSelected: .0125,
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: v => v.length <= 25 || 'Input too long!',
      max100chars: v => v.length <= 100 || 'Input too long!',
      itemsPerPage: 20,
      dialog: false,
      presetDialog: false,
      newPresetName: '',
      editedIndex: -1,
      editedItem: {
        title: '',
        description: '',
        price: 0,
        coupon: 0,
        id: '',
        editing: false
      },
      activeBtn: 1,
      showNav: true,
      defaultItem: {
        title: '',
        description: '',
        price: 0,
        coupon: 0,
        id: '',
        editing: false
      },
      deleteIndex: -1,
      customerName: '',
      invoiceNum: '',
      dateNow: '',
      groupSelected: null,
      allItems: [],
      search: null,
      selectedOptions: [],
      newItem: {
        lvl: '',
        title: '',
        price: 0,
        description: '',
        editing: false
      },
      isCap: false,
      isTen: false,
      isFive: false,
      isEmployee: false,
      reenie: false,
      inline: false,
      headers: [
      { text: 'Title', align: 'left', value: 'title', sortable: false},
      { text: 'Description', value: 'description', sortable: false},
      { text: 'Price', value: 'price', sortable: false},
      { text: 'Coupon', value: 'coupon', sortable: false},
      { text: 'Actions', value: 'action', sortable: false}
      ],
      selectedItems: [],
      warranties: [
      '1 Year Warranty', 
      '2 Year Warranty', 
      '3 Year Warranty', 
      '5 Year Warranty', 
      '10 Year Warranty',
      'LifeTime Warranty',

      '1 Year Parts & 1 Labor Warranty', 
      '2 Year Parts & 2 Year Labor Warranty', 
      '3 Year Parts & 3 Year Labor Warranty', 
      '5 Year Parts & 5 Year Labor Warranty', 
      '10 Year Parts & 10 Year Labor Warranty',

      '1 Year Parts / 1 Year Labor Warranty', 
      '2 Year Parts / 1 Year Labor Warranty', 
      '3 Year Parts / 1 Year Labor Warranty', 
      '5 Year Parts / 1 Year Labor Warranty', 
      '6 Year Parts / 1 Year Labor Warranty', 
      '10 Year Parts / 1 Year Labor Warranty',

      '3 Year Parts / 5 Year Labor Warranty', 
      '3 Year Parts / 10 Year Labor Warranty', 
      '5 Year Parts / 10 Year Labor Warranty', 
      '6 Year Parts / 3 Year Labor Warranty', 
      '10 Year Parts / 1 Year Labor Warranty',
      '10 Year Parts / 2 Year Labor Warranty',
      '10 Year Parts / 5 Year Labor Warranty',
      ],
      defaultOption: {
        active: false,
        capPrice: 0,
        total: 0,
        discount: 0,
        couponTotal: 0,
        sum: 0,
        itemsList: [],
        isCap: false
      },
      option: { 
        1: {
         active: false,
         capPrice: 0,
         total: 0,
         discount: 0,
         couponTotal: 0,
         sum: 0,
         warranty: '1 Year Warranty',
         image: [],
         itemsList: [],
         isCap: false,
         financeAmount: 0,
         financeMonthlyPayment: 0
       },
       2: { 
         active: false,
         capPrice: 0,
         total: 0,
         discount: 0,
         couponTotal: 0,
         sum: 0,
         warranty: '1 Year Warranty',
         image: [],
         itemsList: [],
         isCap: false,
         financeAmount: 0,
         financeMonthlyPayment: 0
       },
       3: { 
         active: false,
         capPrice: 0,
         total: 0,
         discount: 0,
         couponTotal: 0,
         sum: 0,
         warranty: '1 Year Warranty',
         image: [],
         itemsList: [],
         isCap: false,
         financeAmount: 0,
         financeMonthlyPayment: 0
       },
       4: { 
         active: false,
         capPrice: 0,
         total: 0,
         discount: 0,
         couponTotal: 0,
         sum: 0,
         warranty: '1 Year Warranty',
         image: [],
         itemsList: [],
         isCap: false,
         financeAmount: 0,
         financeMonthlyPayment: 0
       },
       5: { 
         active: false,
         capPrice: 0,
         total: 0,
         discount: 0,
         couponTotal: 0,
         sum: 0,
         warranty: '1 Year Warranty',
         image: [],
         itemsList: [],
         isCap: false,
         financeAmount: 0,
         financeMonthlyPayment: 0
       },
       6: { 
         active: false,
         capPrice: 0,
         total: 0,
         discount: 0,
         couponTotal: 0,
         sum: 0,
         warranty: '1 Year Warranty',
         image: [],
         itemsList: [],
         isCap: false,
         financeAmount: 0,
         financeMonthlyPayment: 0
       }
     },
  // levels and items
  levels: {},
  items: [],
  // groups: [],
  pricebook: []
}
},
computed: {
  discounts(){
    return this.$store.state.discounts
  },
  service: {
    set(service) {
      this.$store.commit('service', service)
    },
    get() {
      return this.$store.getters.user.service
    },
  },
  services () {
    return this.$store.getters.services
  },
  flexd() {
    return this.items.length == 0 ? 12 : 6
  },
  formTitle () {
    return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
  },
  groups () {
    return this.$store.state.groups
  },
  user () {
    return this.$store.getters.user
  },
  userIsAuthenticated () {
    return this.$store.getters.user !== null && this.$store.getters.user !== undefined
  },
  company () {
    return this.$store.getters.company
  },
  techName () {
    if (this.user !== null && this.user !== undefined){
      return `${this.$store.getters.user.firstName} ${this.$store.getters.user.lastName}`
    }
    else return ''
  },
presets(){
  return JSON.parse(JSON.stringify(this.$store.getters.presets))
},
filteredItems() {
  return this.$store.state.pricebook.filter((item,i) => {
   return item.title.toLowerCase().match(this.search.toLowerCase()) && item.service == this.user.service
 })
}

},

watch: {
  userIsAuthenticated(val){
    if (val == false){
     this.selectedItems = new Array() 
     this.search = ''
     for (let i = 1; i <= Object.keys(this.option).length; i++){
      this.option[i] = this.defaultOption
    }
  }
},
dialog (val) {
  val || this.close()
},
selectedDiscount(){
  this.capAll()
},
financingSelected (){
  this.capAll()
},
option (){
  this.capAll()
},
search () {
  this.items = []
  this.search !== null
  ? this.items = {...this.filteredItems} 
  : this.items = []
  this.search == null ? null : this.search.length == 0 ? this.items = [] : null
}
},

methods: {
  expansionOpenToggle(xx){
    let open = null;
    for (let i = 1; i <= Object.keys(this.expansionOpen).length; i++){
      if (this.expansionOpen[i] == true) {
        open = i
      }
    }
    if (open == null){
      this.expansionOpen[xx] = !this.expansionOpen[xx]
    }
    if (open != null){
      this.expansionOpen[xx] = true
      this.expansionOpen[open] = false
      open = null
    }

  },
  preview() {
    if (this.invoiceNum.length > 1 && this.customerName.length > 1) {
      this.saveNewHistory()
    } else {
      this.$store.commit('setSnack', "Customer Name And Invoice # Can't Be Blank")
    }
  },
  saveNewHistory () {

    let Option = {
      selectedDiscount: this.selectedDiscount,
      techName: this.techName,
      customerName: this.customerName,
      invoiceNum: this.invoiceNum,
      // dateNow: this.dateNow,
      dateNow: new Date().getTime(),
      option: JSON.parse(JSON.stringify(this.option)),
      cId: this.$store.getters.user.cId,
      userId: this.$store.getters.user.id,
      isCap: this.isCap,
      isTen: this.isTen,
      isFive: this.isFive,
      isEmployee: this.isEmployee,
      financing: this.financing,
      financingSelected: this.financingSelected,
      alternative: this.alternative,
      summarySection: this.summarySection,
      warranty: this.warranty
    }

  // ** update or save new history   
  let index = this.$store.state.history.filter(x=>x.invoiceNum == this.invoiceNum)
  index.length == 0 ? db.collection('history').add(Option) : db.collection('history').doc(index[0].id).set(Option)

  this.$store.commit('setPreview', JSON.parse(JSON.stringify(Option)))
  router.push('/preview')
  // console.log('option', Option)
},
createPdf() {
  window.html2canvas = html2canvas

  const filename  = 'ThisIsYourPDFFilename.pdf'
          // let pdf = new jsPDF()
          const el = document.querySelector("#print")
          // const el = document.body
          // // let canvas = pdf.canvas
          const main = document.querySelector('#main')
          main.style.display = 'none'
          // this.createStyle()

          html2canvas(el).then(canvas => {
            let image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
          // document.body.appendChild(canvas)
          window.location.href = image
        });
          main.style.display = 'initial'

    // html2canvas(document.querySelector('#print')).then(canvas => {
    //   let pdf = new jsPDF('p', 'mm', 'a4');
    //   pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
    //   pdf.save(filename);
    // });
    // html2canvas(el).then(canvas=>{
    //   let image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
    //   window.location.href = image
    // })\
  },
  printPDF(quality = 1){
    const filename  = 'ThisIsYourPDFFilename.pdf'

    html2canvas(document.querySelector('#nodeToRenderAsPDF'), 
      {scale: quality}
      ).then(canvas => {
        let pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
        pdf.save(filename);
      })
    },
    removeItem(item, optNum) {
      let ind = this.option[optNum].itemsList.indexOf(item)
      this.option[optNum].itemsList.splice(ind, 1)
      this.sum()
    },
    editItem (item, optInd) {
      this.editedIndex = this.pricebook.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.option[optInd].itemsList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true

    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)

      this.sum()
    },
    cancel () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Canceled'
    },
    open () {
      // this.snack = true
      // this.snackColor = 'info'
      // this.snackText = 'Press Enter To Save'
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.pricebook[this.editedIndex], this.editedItem)
      } else {
            // save new
            this.pricebook.push(this.editedItem)
          }
          this.close()
          this.snack = true
          this.snackColor = 'success'
          this.snackText = 'Saved!'
        },
        anim (e) {
          let random = Math.floor(Math.random() * 10)
          let animations = ['zoomOut', 'zoomOutDown','zoomOutRight', 'hinge', 'rollOut','rotateOut','rotateOutDownLeft','fadeOut','fadeOutDownBig','bounceOutDown', ]
          e.target.parentNode.classList.add(animations[random])
          setTimeout(function(){
           e.target.parentNode.classList.remove(animations[random])
         }, 1500)
        },
        showGroupItems (group) {
          // console.log('pricebook check', this.pricebook.map(v=>v.group) )
          // this.search = null
          this.groupSelected = group
          this.items = []
          this.items = this.$store.state.pricebook.filter(v => v.group.toUpperCase() == group.toUpperCase() && v.service == this.user.service)
        },

        unSelect (item) {
          Object.keys(this.levels).map(v=> this.levels[v].active = false)
          if (item) {
           item.active = true
         }
       },
       toggle () {
        // this.inline ? this.Toggle = 'Row' : this.Toggle = 'Column';
      },
      clear () {
        for (let i = 1; i <= Object.keys(this.option).length; i++){
         this.option[i].itemsList = new Array()
         this.option[i].image = new Array()
         this.option[i].warranty = '1 Year Warranty',
         this.option[i].capPrice = 0
         this.option[i].isCap = false
         if (this.isCap == true){
          this.option[i].isCap = true
        }
      }
      this.sum()
      this.$store.commit('clearPresets')
      this.$store.dispatch("getUserPresets")

    },
    reset () {
      let v = confirm("Are You Sure You Want To Clear All Options?")
      if (v) {
       this.clear()
     }

   },
   print () {
    // this.$store.dispatch('windowPrint')
    if (this.invoiceNum.length > 1 && this.customerName.length > 1) {
      this.saveNewHistory()
      this.$store.commit('drawerMenu', false)
      setTimeout(()=> window.print(), 100)
    } else {
      this.$store.commit('setSnack', "Customer Name And Invoice # Can't Be Blank")
    }
  },
  preset () {
   if (!this.option[1].itemsList.length == 0 || !this.option[2].itemsList.length == 0 || !this.option[3].itemsList.length == 0 || !this.option[4].itemsList.length == 0 || !this.option[5].itemsList.length == 0 || !this.option[6].itemsList.length == 0 ){
    let v = confirm("This Will Reset All Options And Load Preset Options.")
    if (v) {
     this.clear()
     this.loadPreset()
   }
 } else {
  this.clear()
  this.loadPreset()
}
},
saveNewPreset () {
  for (let i = 1; i <= Object.keys(this.option).length; i++){
    if (this.option[i].image == undefined){
      this.option[i].image = new Array()
    }
  }
  let Preset = {
   options: this.option,
   cid: this.$store.getters.user.cId,
   presetName: this.newPresetName,
   userId: this.$store.getters.user.id,
   alternative: this.alternative,
   summarySection: this.summarySection,
   warranty: this.warranty
 }
 db.collection('presets').add(Preset)
 this.newPresetName = ''
},
loadPreset () {
 for (let i = 1; i <= Object.keys(this.option).length; i++){
  this.option[i].active = false
}
},
loadPreset2(preset) {
  this.clear()
  setTimeout(()=>{
    this.alternative = preset.alternative,
    this.summarySection = preset.summarySection,
    this.warranty = preset.warranty,
    this.option = preset.options
  }, 100)
},
deletePreset (){
  let preset = this.presetItem
  db.collection('presets').doc(preset.id).delete()
  this.$store.commit('setSnack', 'Preset Deleted Successfully')
  this.deletePresetDialog = false
},
capAll () {
 for (let i = 1; i <= Object.keys(this.option).length; i++){
  this.selectedDiscount.amount == .15 ? this.isCap = true : this.isCap = false
  this.selectedDiscount.amount == .10 ? this.isTen = true : this.isTen = false
  this.selectedDiscount.amount == .05 ? this.isFive = true : this.isFive = false
  this.selectedDiscount.amount == .40 ? this.isEmployee = true : this.isEmployee = false

  if (this.isCap == true){
   this.option[i].isCap = true
   this.sum()
 }
 if (!this.isCap){
  if (this.option[i].capPrice == 0){
    this.option[i].isCap = false
  }
}
}
setTimeout(()=> this.sum(), 100)
},
cap () {
 for (let i = 1; i <= Object.keys(this.option).length; i++){
  if (this.option[i].isCap || this.option[i].capPrice !== 0){
   this.option[i].discount = Math.round(this.option[i].total * .15)
 }
        // check if option cap is not selected
        if (!this.option[i].isCap){
          this.option[i].discount = 0
        }

        // recalculate pricing with cap plan 
        this.option[i].sum = (this.option[i].total += this.option[i].capPrice) - this.option[i].discount  
      }
      this.discount()
    },
    sum () {
      for (let i = 1; i <= Object.keys(this.option).length; i++){
        this.option[i].discount = 0
        // get coupon total
        this.option[i].couponTotal = this.option[i].itemsList.reduce((t,v,i,a)=>t+=parseInt(a[i].coupon),0)
        // get the sum and total of each option
        this.option[i].sum = this.option[i].total = this.option[i].itemsList.reduce((t,v,i,a)=>t+=parseInt(a[i].price),0)

        // check for cap
      }
      this.cap()

    },
    add (item){

      for (let i = 1; i <= Object.keys(this.option).length; i++){
        if (this.option[i].active){ 
         this.option[i].itemsList.push(item) 
         if (item.capPrice){
          this.option[i].capPrice += item.capPrice
          this.option[i].isCap = true
        }
      }
    }
    this.sum()
  },
  discount (rate) {
    for (let i = 1; i <= Object.keys(this.option).length; i++){
        // minus coupon price before doing any percentage discount
        // discounts for others by rate 
        let rate = this.selectedDiscount.amount

        if (!this.option[i].isCap && this.option[i].capPrice == 0){

          this.option[i].sum = this.option[i].total = this.option[i].itemsList.reduce((t,v,i,a)=>t+=parseInt(a[i].price),0)
            this.option[i].total -= this.option[i].couponTotal
            this.option[i].discount = Math.round(this.option[i].total * rate)
            this.option[i].total += this.option[i].couponTotal
          }
        // update discount view to include coupon
        this.option[i].discount += this.option[i].couponTotal
        this.option[i].sum = this.option[i].total - this.option[i].discount
        this.calculateFinancing()
      }  
    },
    calculateFinancing () {
      for (let i = 1; i <= Object.keys(this.option).length; i++){
        this.option[i].financeAmount = Math.ceil(this.option[i].sum / .91)
          this.option[i].financeMonthlyPayment = Math.ceil((this.option[i].sum / .91) * this.financingSelected)
        }
      },
      deleteItem (item, i, x) {
       if (item.capPrice) {
        this.option[x].capPrice -= item.capPrice
      }
      if (this.option[x].capPrice == 0) {
        this.option[x].isCap = false
      }
      if (this.isCap) {
        this.capAll()
      }
      this.option[x].itemsList.splice(i, 1)
      this.sum()
    }
  },
  created() {
   this.dateNow = new Date().toDateString().slice(4)
        window.onbeforeprint = (event) => { 
          this.$store.commit('drawerMenu', false)
        }
// this.$store.state.user.id && !this.$store.state.user.service ? this.$store.commit('settingsDialog', true) : null

},
mounted(){}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h6.alternative {
    font-size: 22px;
  }
  span.warranty {
    padding: 0px 15px 0px 15px;
    font-size: .8em;
    float: right;
    border: 1px solid #666;
    border-radius: 60%;
    color: #666;
  }
  footer {
    background: #fff;
  }
  body, html {
    height: 100%;
    overflow: hidden;
  }
  .clone {
    color: #eee;
    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
    background-color: #f5f5f5;
    padding: 0 16px;
    display: inline-flex;
    height: 36px;
    border-radius: 2px;
    justify-content: center;
    flex: 0 0 auto;
    font-size: 14px;
    font-weight: 500;
    min-width: 88px;
    outline: 0;
    text-transform: uppercase !important;
    text-decoration: none;
    vertical-align: middle;
  }
  .clone:hover {
    cursor: pointer;
  }  
  .names {
    position: absolute; 
    left: 80px; 
    bottom: 5px;
  }
  .relative {
    position: relative;
  }
  #footer {
    position: absolute;
    text-align: center;
    padding: 0;
    margin: 0 auto;
    bottom: 0;
    width: 98%;
    background-color: #fff;
    height: 70px;
  }
  #print {
    min-height: 11in;
  /*height: 215.9mm;
  width: 279.4mm;*/
  /*height: 11in;*/
  /*width: 8.5in;*/
  /*width: 9in;*/
  position: relative;
  max-width: 900px;
  top: 0;
  /*size: letter portrait;*/
  background-color: #fff;
  margin: 0 auto;
  margin-bottom: 30px;
}

ul {
  list-style-type: none;
}
.activated, button.hover:hover, button.hover:active {
  background: black;
  border: 1px solid;
}
li span {
  font-weight: 600;
  font-size: 1em;
}
li.myfont {
  font-weight: 600;
  margin-right: 0;
  /*margin-left: 5px;*/
  text-transform: capitalize;
  color: #333;
  display: block;

}
p.underline {
  border-bottom: 1px solid #000;
  margin-bottom: 16px;
  width: 100%;
  line-height: 1;
}
#header {
  position: relative;
  width: 100%;
}
.list-group {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  /*background-color: #fff;*/
  border: 1px solid rgba(0, 0, 0, .125)
}
.list-group-item:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: .25rem;
}
p.mbNone {
  margin-bottom: 0;
}
img.logo {
  margin-top: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: 34%;
  max-width: 100%;
  max-height: 100%;
}
.invoiceNames {
  height: 150px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  margin-top: 0;
  padding-top: 0;
  color: #666;
}
.cname, .tname, .invoice, .date {
  position: absolute;
  margin: 0;
  padding: 0;
  font-size: 1rem;
  z-index: 1;
  line-height: 0;
}
.cname {
  left: 47%;
  top: 43%;
  
}
.tname {
  left: 47%;
  top: 76%;
}
.invoice {
  left: 84%;
  top: 43%;
}
.date {
  left: 81%;
  top: 75%;
}
.black {
  color: black;
}
.shade:nth-child(even){
  /*background-color: #eee;*/
}
#optionContainer{
  padding-bottom: 0px;
}

/* summary/diagnostics header */
h4.recommendations {
  font-size: 1em;
  color: #666;
  margin-top: 25px;
}
/* solutions header*/
h5#solutions {
  font-size: 1em;
  color: #666;
}
/*option # heading*/
h6.options{
  font-weight: bolder;
  font-size: .9em;
  /*color: #aaa;*/
}
/*description text*/
li span {
  font-size: .8em;
}
ul.descriptionList li {
  line-height: 1 !important;
}
/*investment price*/
.pricing {
  font-size: .8em;
  text-align: right;
}
.list-group-item {
  border: 1px solid rgba(0, 0, 0, .325)
}
.text-muted {
  color: #6c757d !important;
}
.tableOptions {
  margin: 0 auto;
  width: 100%;
}
.textShadow {
  color: #eee;
  font-size: 20px;
  text-shadow: -1px 1px 2px #444,
  1px 1px 2px #444,
  1px -1px 0 #444,
  -1px -1px 0 #444;
}
.header {
  position: fixed;
  top: 0;
}
.header, .header-space {
  height: 70px;
}
#footer, .footer-space {
  height: 70px;
}

@media screen and (min-width: 1000px) {
  /*h6.options, li span, .pricing {
    font-size: .9em;
    }*/
    #footer, #footer h2, #footer h5{
      /*font-size: 1em;*/
    }
  }

  @media print {
    * {
      color: #000 !important;
    }
    @page {
      margin: 0mm 2mm 0mm 2mm;
      padding: 0mm 0mm 0mm 0mm;
      size: letter portrait;
      /*max-height: 100%;*/
      /*max-width: 100%;*/
      /*height: 11in;*/
      /*width: 8.5in;*/
    }
    .toHide {
      position: absolute;
      z-index: -2;
      display: none;
    }
    #print {
      height: 11in;
      top: 0;
      left: 0;
    }
  /* #footer {
    position: absolute;
    z-index: 0;
    opacity: .9;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    margin-bottom: 0px;
    padding-bottom: 0px;
    text-align: center;
    }*/
    #footer h2 {
      text-align: center;
      margin: 0 auto;
    }
    #footer h5 {
      text-align: center;
      margin: 0 auto;
    }
    #footer{
      position: fixed;
      bottom: 0;
    }
    .cname, .tname, .invoice, .date {
      font-size: 16px;
    }
    img.logo {
      margin-top: 10px;
      position: absolute;
      top: 0;
      left: 0;
      width: 35%;
      max-width: 100%;
      max-height: 100%;
    }
    /* summary/diagnostics header */
    h4.recommendations {
      font-size: 16px;
      color: #666;
      margin-top: 25px;
    }
    /* solutions header*/
    h5#solutions {
      font-size: 14px;
      color: #666;
    }
    /*option # heading*/
    h6.options{
      font-size: 16px;
      font-weight: bolder;
      color: #666;
    }
    /*description text*/
    li span {
      font-size: 12px;
      color: #555;
    }
    span.warranty {
      font-size: 12px;
      display: inline-block;
      color: #666 !important;
      padding: 0px 6px 0px 6px;

    }
    ul.descriptionList li {
      line-height: .9 !important;
    }
    /*investment price*/
    .pricing {
      font-size: 12px;
      color: #666;
    }
    .shade:nth-child(even) {
      background: #fff;
    }
    .text-muted {
      color: #6c757d !important;
    }

  }


  .activated, button.hover:hover, button.hover:active {
    color: black;
    border: 2px solid;
  }
  h1,
  h2 {
    font-weight: normal;
  }

/*h6.options {
  font-size: 1.1em;
  font-weight: bolder;
  color: black;
  }*/
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  button.animated {
    margin-bottom: 3px;
    -webkit-appearance: button;
    -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: center;
    cursor: default;
    box-sizing: border-box;
    margin: .5em;
    padding: .5em;
    border-width: 1px;
    border-style: solid;
    border-image: initial;
    border-width: 1px;
    border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);
    border-image: initial;
    text-transform: capitalize;

  }
  button:hover {
    /*background-color: blue !important;*/
  }

  .block {
    display: block;
  }
  .recommendations {
    font-size: 2vw;
  }

  .text-capitalize {
    text-transform: capitalize !important;
  }

  * {
   /*border: 1px solid red !important;*/
 }

</style>




